// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import styled from 'styled-components';

const StyledContainer = styled.div`
  @media (max-width: 768px) {
    display: inline-block;
  }

  display: none;
  cursor: pointer;
  position: absolute;
  left: 32px;
  bottom: 15px;

  .bar {
    display: block;
    width: 35px;
    height: 5px;
    background-color: #ffffff;
    margin: 6px 0;
    transition: 0.4s;
  }

  .bar1 {
    transform: ${props =>
      props.expanded ? 'rotate(-45deg) translate(-8px, 6px)' : ''};
  }

  .bar2 {
    opacity: ${props => (props.expanded ? '0' : '')};
  }

  .bar3 {
    transform: ${props =>
      props.expanded ? 'rotate(45deg) translate(-9px, -8px)' : ''};
  }
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const MenuToggle = ({ isExpanded, onClick }) => {
  return (
    <StyledContainer expanded={isExpanded} onClick={() => onClick(!isExpanded)}>
      <span className='bar bar1' />
      <span className='bar bar2' />
      <span className='bar bar3' />
    </StyledContainer>
  );
};

export default MenuToggle;
